import { render, staticRenderFns } from "./SportsOverview.vue?vue&type=template&id=0ee7718e&scoped=true&"
import script from "./SportsOverview.vue?vue&type=script&lang=js&"
export * from "./SportsOverview.vue?vue&type=script&lang=js&"
import style0 from "./SportsOverview.vue?vue&type=style&index=0&id=0ee7718e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee7718e",
  null
  
)

export default component.exports